// CRUDProvider.tsx
import axios from 'axios';
import { API_URL } from "../constants";
import { PaginationRequest } from '../types/pagination';
import i18n from './../locales/i18n';
import { cookies } from './../cookies';

export async function getAll<T>(url_path: string, pagination: PaginationRequest, image_size: string | undefined) : Promise<T> {
    // create order by from data grid sort option
    // create URL for objects search controller API
    // with id search URL parameter in order to get objects slugged id
    const paginate = new URLSearchParams();

    for (const key in pagination) {
        if (Object.prototype.hasOwnProperty.call(pagination, key)) {
            let value = pagination[key as keyof PaginationRequest]; // Type assertion for safety
            if(key === 'page') {
                value = value + 1;
            }
            if (value !== undefined) { // Handle optional properties
                paginate.append(key, String(value)); // Ensure value is a string
            }
        }
    }

    let url = `${API_URL}/${url_path}/?${paginate.toString()}&lang=${cookies.get('language') || i18n.language}`;
    if(image_size !== undefined) {
        url = `${url}&image_size=${image_size}`;
    }

    return await axios.get(url);
};

export async function getOne<T>(url_path: string, slug: string, image_size: string | undefined, popup: string | undefined) : Promise<T> {
    // create URL for objects search controller API
    // with id search URL parameter in order to get objects slugged id
    let url = `${API_URL}/${url_path}/${slug}/?lang=${cookies.get('language') || i18n.language}`;
    if(popup !== undefined) {
        url = `${API_URL}/${url_path}/?slug=${slug}&popup=${popup}&lang=${cookies.get('language') || i18n.language}`;
    }
    if(image_size !== undefined) {
        url = `${url}&image_size=${image_size}`;
    }

    return await axios.get(url);
};

export async function update<T>(url_path: string, slug: string, data: any, contentType: string) : Promise<T> {
    // create URL for objects update controller API
    // with slug search URL parameter in order to get object that has to be updated
    let url = `${API_URL}/${url_path}`;
    if(slug) {
        url = `${API_URL}/${url_path}/${slug}/`;
    }
    if(!contentType) {
        contentType = 'application/json';
    }

    return await axios.put(url, data, {
        headers: {
            'Content-Type': contentType,
        }
    });
};

export async function create<T>(url_path: string, data: any, contentType: string) : Promise<T> {
    // create URL for objects create controller API
    let url = `${API_URL}/${url_path}/`;
    if(!contentType) {
        contentType = 'application/json';
    }

    return await axios.post(url, data, {
        headers: {
            'Content-Type': contentType
        }
    });
};
